import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { CreateReminder } from 'app/dtos/reminder/createReminder';
import { UpdateReminder } from 'app/dtos/reminder/updateReminder';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllReminders(page,size){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Reminder,
      queryString:`Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createReminder(createReminder:CreateReminder){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Reminder
    },createReminder);
    return await firstValueFrom(observable);
  }

  async updateReminder(updateReminder:UpdateReminder){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Reminder
    },updateReminder);
    return await firstValueFrom(observable);
  }

  async getByIdReminder(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Reminder
    },id);
    return await firstValueFrom(observable);
  }
}
